import React, { useState } from 'react';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import { PatientConsentType } from '../../Commands/WritePatientConsent';
import PatientConsentModal from './PatientConsentModal';
import { useNCZIContext } from '../../Services/NCZIContext';

interface Props {
	loadData: () => void;
	code?: string;
	consentType: PatientConsentType;
}

const PatientConsentButton: React.FC<Props> = ({
	loadData,
	code,
	consentType,
}) => {
	const { patientIdentifier } = useNCZIContext();

	const [isPresenceConfirmationOpen, setIsPresenceConfirmationOpen] =
		useState(false);

	const handleClosePatientPresenceConfirmation = async (
		needReload: boolean,
	) => {
		setIsPresenceConfirmationOpen(false);
		if (needReload) {
			loadData();
		}
	};

	const showPatientConfirmation =
		['W900001', 'E900002', 'E900001'].indexOf(code || '') !== -1;

	if (!patientIdentifier || !showPatientConfirmation) {
		return <></>;
	}

	return (
		<>
			<LinkButton
				title='nczi.patientPresenceConfirmation.actionButton'
				theme={Theme.BLUE}
				onClick={() => setIsPresenceConfirmationOpen(true)}
			/>
			<PatientConsentModal
				opened={isPresenceConfirmationOpen}
				onClose={handleClosePatientPresenceConfirmation}
				patientIdentifier={patientIdentifier}
				consentType={consentType}
			/>
		</>
	);
};

export default PatientConsentButton;
